import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";
import {LabelSmall} from "@khanacademy/wonder-blocks-typography";
import {doNotTranslateYet} from "@khan/i18n";

import checkIcon from "@phosphor-icons/core/bold/check-bold.svg";
import xIcon from "@phosphor-icons/core/bold/x-bold.svg";

type Props = {
    criteria: Array<{description: string; isSatisfied: boolean}>;
};

export default function CriteriaList({criteria}: Props): React.ReactElement {
    return (
        <ul className={css(styles.criteriaList)}>
            {criteria.map((criterion) => (
                <li
                    key={criterion.description}
                    className={css(styles.criterion)}
                >
                    {criterion.isSatisfied ? (
                        <PhosphorIcon
                            icon={checkIcon}
                            color={color.green}
                            size="small"
                            role="img"
                            aria-label={doNotTranslateYet`Satisfied`}
                            style={styles.icon}
                        />
                    ) : (
                        <PhosphorIcon
                            icon={xIcon}
                            color={color.red}
                            size="small"
                            role="img"
                            aria-label={doNotTranslateYet`Not satisfied`}
                            style={styles.icon}
                        />
                    )}
                    <LabelSmall>{criterion.description}</LabelSmall>
                </li>
            ))}
        </ul>
    );
}

const styles = StyleSheet.create({
    criteriaList: {
        padding: spacing.medium_16,
    },
    icon: {
        marginTop: 1,
    },
    criterion: {
        display: "flex",
        flexDirection: "row",
        gap: spacing.xxSmall_6,
        marginBottom: spacing.xxSmall_6,
    },
});
